export const maskToLastChars = (value, visibleChars = 10) => {
  if (value === null || value === undefined || value === "") return value;

  const stringValue = String(value);
  if (stringValue.length <= visibleChars) {
    return "*".repeat(stringValue.length);
  }

  return `${"*".repeat(stringValue.length - visibleChars)}${stringValue.slice(-visibleChars)}`;
};
